import { render, staticRenderFns } from "./VariantDisplay.vue?vue&type=template&id=3254ee89&scoped=true&"
import script from "./VariantDisplay.vue?vue&type=script&lang=js&"
export * from "./VariantDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VariantDisplay.vue?vue&type=style&index=0&id=3254ee89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254ee89",
  null
  
)

export default component.exports